import { render, staticRenderFns } from "./DetailCourseCombo.vue?vue&type=template&id=720c6330"
import script from "./DetailCourseCombo.vue?vue&type=script&lang=js"
export * from "./DetailCourseCombo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports